import { firstWord } from '../../utils/truncate-entity-name'
import styles from './entity-notice-entry.module.scss'

export interface EntityNoticeTitleProps {
  template: string
  entityName: string
}

export function EntityNoticeTitle({ template, entityName }: EntityNoticeTitleProps) {
  const [prefix, suffix] = template.split('{Nome}')

  return (
    <>
      {prefix}
      <span className={styles.entityName}>{firstWord(entityName)}</span>
      {suffix}
    </>
  )
}
